import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { Coach, NewCoachRequest, NewCoachResponse, PublicCoach } from "@/services/bedrock/dtos/Coaches";

const COACHES_SERVICE = `${Constants.API_URL}/bedrock/coaches`;

export interface CoachUpdateParams {
  companyName?: string;
  contactEmail?: string;
  contactPhone?: string;
  directSupportToCoach?: boolean;
}

export class CoachesServices {
  @scCatchServiceException()
  static async createCoach(request: NewCoachRequest): Promise<NewCoachResponse> {
    const { data } = await axios.post<NewCoachResponse>(COACHES_SERVICE, request);
    return data;
  }

  @scCatchServiceException()
  static async getPublicCoach(coachId: number): Promise<PublicCoach> {
    const { data } = await axios.get<PublicCoach>(COACHES_SERVICE + `/${coachId}/public`);
    return data;
  }

  @scCatchServiceException()
  static async getCoach(coachId: string | number): Promise<Coach> {
    const { data } = await axios.get<Coach>(`${COACHES_SERVICE}/${coachId}`);
    return data;
  }

  @scCatchServiceException()
  static async updateCoach(id: string | number, params: CoachUpdateParams): Promise<Coach> {
    const { data } = await axios.patch<Coach>(`${COACHES_SERVICE}/${id}`, params);
    return data;
  }
}
